import type { NavigationGuard } from "vue-router";

import { useUserStore } from "@/stores";

export function redirectSearchEntryGuard(): NavigationGuard {
  return async (to) => {
    const userStore = useUserStore();
    const { settings } = await userStore.getUser();

    if (settings.preferredSearchView === "compact") {
      return { ...to, name: "search.compact" };
    } else {
      return { ...to, name: "search.classic" };
    }
  };
}
